import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import { Flex } from 'reflexbox'

import {updateObject} from 'helpers/ReducerUtil'

import CpuConfig from './CpuConfig'
import CheckboxFilter from 'components/custom/CheckboxFilter/index'
import AddPopupDialog from 'components/custom/AddPopupDialog/index'
import AddPopup from 'components/custom/AddPopup/index'

import styles from './styles.scss'

import { TableCell } from 'react-toolbox/lib/table'
import {
  error,
} from 'containers/App/Notification/actions'
import T from 'i18n-react'

class NotebookCpu extends Component {

  addConfigRestriction = (value) => {
    const { values, onUpdateConfig } = this.props
    if (values.length + value.length <= 5){
      onUpdateConfig(value)
    }
  }

  addConfigSourceRestriction = (value) => {
    const { onUpdateConfigSource, values } = this.props
    if (values.length + value.length <= 5){
      onUpdateConfigSource(value)
    }
  }

  render() {
    const {
      values,
      sources,
      segment,
      togglePopup,
      configSelection,
      configSource,
      curConfig,
      filterPairs,
      onTogglePopup,
      onArchChange,
      onBrandChange,
      onClassChange,
      onUpdateConfig,
      onUpdateConfigSource,
      onAddPart,
      onDeletePart,
      onModelNameChange,
      onUpdateCurConfig,
      onRefreshFilter,
      initFilters,
      archFilter,
      brandFilter,
      classFilter,
    } = this.props

    const filterHandlers = {
      architecture: onArchChange,
      brand: onBrandChange,
      classification: onClassChange,
    }

    this.filterStatus = {
      architecture: archFilter,
      brand: brandFilter,
      classification: classFilter,
    }

    const tableHeadContent = {
        architecture: <TableCell key={0}>Architecture</TableCell>,
        brand: <TableCell key={1}>Brand</TableCell>,
        classification: <TableCell key={2}>Classification</TableCell>,
    }

    const singleCpuSelectableOnly = segment === 'Enterprise'
    const allowsAddCpu = !singleCpuSelectableOnly || values.length === 0

    return (
      <Flex styleName="CpuWrapper">
        <CpuConfig
          sources={sources}
          values={values}
          filterStatus={this.filterStatus}
          togglePopup={togglePopup}
          initFilters={initFilters}
          onTogglePopup={onTogglePopup}
          onDeletePart={onDeletePart}
          onModelNameChange={onModelNameChange}
          onUpdateCurConfig={onUpdateCurConfig}
          showAddCpuButton = {allowsAddCpu}
        />
        <AddPopupDialog
            togglePopup={togglePopup}
            tabTitles={['Cpu']}
            onTogglePopup={onTogglePopup}
            onUpdateConfig={onUpdateConfig}
            onUpdateConfigSource={onUpdateConfigSource}
            onRefreshFilter={onRefreshFilter}
        >
          <AddPopup
            sources={sources}
            configSelection={configSelection}
            configSource={configSource}
            curConfig={curConfig}
            onTogglePopup={onTogglePopup}
            onAddPart={onAddPart}
            filterStatus={this.filterStatus}
            onUpdateConfig={this.addConfigRestriction}
            onUpdateConfigSource={this.addConfigSourceRestriction}
            tableHeadContent={tableHeadContent}
            onRefreshFilter={onRefreshFilter}
            multiSelectable = {!singleCpuSelectableOnly}
          >
            <CheckboxFilter
              sources={sources}
              curConfig={curConfig}
              filterHandlers={filterHandlers}
              filterStatus={this.filterStatus}
              onUpdateConfig={onUpdateConfig}
              onUpdateConfigSource={onUpdateConfigSource}
              onRefreshFilter={onRefreshFilter}
              filterPairs={filterPairs}
            />
          </AddPopup>
        </AddPopupDialog>
      </Flex>
    )
  }
}

export default CSSModules(NotebookCpu, styles)
